import { render, staticRenderFns } from "./ReImport.vue?vue&type=template&id=5bdd2fec&scoped=true&"
import script from "./ReImport.vue?vue&type=script&lang=js&"
export * from "./ReImport.vue?vue&type=script&lang=js&"
import style0 from "./ReImport.vue?vue&type=style&index=0&id=5bdd2fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd2fec",
  null
  
)

export default component.exports